module.exports = new __parcel__URL__("img-placeholder-6.88847e66.jpg").toString();